import React from 'react';
import { Field, reduxForm } from 'redux-form';

import UploadField from '../../shared/form-elements/upload';

const Form = (props) => {
	return (
		<div className="">
			<form className="position-relative top--20 min-width-200">
				<div className="ui-form__element">
					<Field
						name="report"
						searchable={false}
						placeholder="file (only xlsx)"
						multi={true}
						component={UploadField}
						preparationFile={props.preparationFile}
					/>
				</div>
			</form>
		</div>
	);
};

export default reduxForm({
	form: 'landingReportFileSelectForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/landing-reports/components/report-file-form.js